import { ColorPicker, Radio, Form, Typography, Modal, Row, Col, Button, Popover, DatePicker, Space, Input, Popconfirm, Checkbox, Select, InputNumber } from 'antd';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { DeleteOutlined } from '@ant-design/icons';
import AdminModal from "./AdminModal";
import { useFormulaType } from './FormulaType/controller/FormulaTypeController';
import { useUnitType } from './UnitType/controller/UnitTypeController';
const { Title, Paragraph, Text, Link } = Typography;
const { TextArea } = Input;
const { confirm } = Modal;
const TutionFeeDetailModal = ({
    form,
    ...props }) => {
    const [lesson, setLesson] = useState([]);
    const [count, setCount] = useState(0)
    const onFormFinish = (values) => {
        if (props.edit) {
            props.handleEdit(values)
        }
        else {
            props.handleSubmit(values)

        }
    }
    const isCourseFee = (count) => {
        let CourseFeeFormulaTypeData = FormulaTypeOption.find((ele => ele.cName === "課程費"))
        let CourseFeeFormulaType = CourseFeeFormulaTypeData?.iFormulaType
        let iFormulaType = form.getFieldValue("iFormulaType")
        if (iFormulaType === CourseFeeFormulaType) {
            return true
        }
        else {
            return false

        }
    }
    const {
        FormulaTypeOption,
        getFormulaTypeOption
    } = useFormulaType(
        {
            onFinish: () => { },
            onBefore: () => { }
        }
    )
    const {
        getUnitTypeOption,
        UnitTypeOption
    } = useUnitType({
        onBefore: () => { },
        onFinish: () => { }
    })
    useEffect(() => {
        getUnitTypeOption({})
        getFormulaTypeOption({})
        axios
            .get('/cramSchool/api/lesson')
            .then((response) => {
                let data_tmp = [];
                response.data.data.map((value, index) => {
                    let data_json_tmp = {};
                    data_json_tmp['value'] = value['lesson_id']
                    data_json_tmp['label'] = `${value['name']}`;
                    data_tmp.push(data_json_tmp);
                })
                setLesson(data_tmp);
            })
    }, [])

    return (<>
        <AdminModal
            {...props}
            handleSubmit={() => {
                form.submit()
            }}

            handleEdit={() => {
                form.submit()
            }}
            title={(<>
                <Col style={{ fontWeight: 'bold', fontSize: '20px', position: 'absolute', zIndex: 99, top: 53, left: 32 }} >{props.title}</Col>
            </>)}
        >
            <Row gutter={[8, 8]} align={'middle'}>
                <Col span={24}>
                    <Form
                        form={form}
                        name="control-hooks"
                        onFinish={onFormFinish}
                        style={{
                            maxWidth: 600,
                        }}
                        labelWrap
                    >
                        <Row>
                            <Form.Item
                                name={"iFormulaID"}
                            >
                            </Form.Item>
                            <Form.Item
                                hidden
                                name={"lesson_salary_table_formula"}
                                initialValue={[]}
                            >
                                <Input>
                                </Input>
                            </Form.Item>
                            <Col span={18}>
                                <Form.Item
                                    name={"iSerialID"}
                                    label={"代碼編號"}
                                    labelCol={
                                        { span: 8 }
                                    }
                                    wrapperCol={
                                        { span: 14 }
                                    }

                                >
                                    <Input
                                        style={{ width: 180 }}
                                        placeholder={'請輸入索引代碼'}
                                        type='text'
                                        name="iRuleID"
                                        onChange={e => props.setEditCard(pre => ({ ...pre, iSerialID: e.target.value }))}
                                        disabled={props.editcard?.iFormulaID === 0}
                                    />
                                </Form.Item>

                            </Col>
                            {/* <Col span={6}>
                                <Form.Item>
                                    <Checkbox
                                        checked={props.editcard.iFormulaID === 0}
                                        onChange={e => props.setEditCard(pre => ({
                                            ...pre,
                                            iFormulaID: e.target.checked === true ? 0 : props.editcard.iSerialID
                                        }))}>自動產生</Checkbox>
                                </Form.Item>
                            </Col> */}
                            {/* <Col span={6}>項目種類</Col> */}
                            <Col span={24}>
                                <Form.Item
                                    name={"iFormulaType"}
                                    rules={[
                                        {
                                            required: true,
                                            message: "請選擇項目種類"
                                        }
                                    ]}
                                    label={"項目種類"}
                                    labelCol={
                                        { span: 6 }
                                    }
                                    wrapperCol={
                                        { span: 18 }
                                    }
                                >
                                    <Select
                                        placeholder='請選擇項目種類'
                                        style={{ width: 200 }}
                                        options={
                                            FormulaTypeOption
                                        }
                                        onChange={(value) => {
                                            setCount(pre => pre + 1)
                                            props.setEditCard(prev => {
                                                return (
                                                    {
                                                        ...prev,
                                                        iFormulaType: value,
                                                    }
                                                )
                                            })
                                        }
                                        }

                                    />

                                </Form.Item>

                            </Col>
                            <Col span={24}>
                                <Form.Item
                                    name={"cName"}
                                    rules={[
                                        {
                                            required: true,
                                            message: "請輸入項目名稱"
                                        }
                                    ]}
                                    label={"項目名稱"}
                                    labelCol={
                                        { span: 6 }
                                    }
                                    wrapperCol={
                                        { span: 18 }
                                    }
                                >
                                    <Input
                                        placeholder={'請輸入項目名稱'}
                                        type='text'
                                        // value={props.editcard['cName']}
                                        onChange={e => props.setEditCard(prev => {
                                            return (
                                                {
                                                    ...prev,
                                                    cName: e.target.value,
                                                }
                                            )
                                        })}
                                        autoComplete="off" />
                                </Form.Item>
                            </Col>

                            <Col span={24}>
                                <Form.Item
                                    initialValue={[]}
                                    name={"lesson_id"}
                                    label={"課程綁定"}
                                    labelCol={
                                        { span: 6 }
                                    }
                                    wrapperCol={
                                        { span: 18 }
                                    }
                                >
                                    <Select
                                        mode='multiple'
                                        placeholder='請選擇課程'
                                        style={{ width: '100%' }}
                                        options={lesson}
                                        filterOption={(input, option) => (option?.label ?? '').includes(input)}
                                        // value={props.editcard['lesson_id'] ?? []}
                                        onChange={value => props.setEditCard(prev => {
                                            return (
                                                {
                                                    ...prev,
                                                    lesson_id: value,
                                                }
                                            )
                                        })}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={24}>
                                <Form.Item
                                    label={"預設價格"}
                                    name={"iDefaultValue"}
                                    labelCol={
                                        { span: 6 }
                                    }
                                    wrapperCol={
                                        { span: 18 }
                                    }
                                    rules={[
                                        {
                                            required: true,
                                            message: "請填入價格"
                                        }
                                    ]}
                                >
                                    <InputNumber
                                     min={0}
                                     placeholder={'請輸入預設價格'}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={24}>
                                <Form.Item
                                    label={"適用價格"}
                                    labelCol={
                                        { span: 6 }
                                    }
                                    wrapperCol={
                                        { span: 18 }
                                    }
                                >
                                    <Form.List
                                        name={"Salary_TABLE_FormulaRuleHistory_data"}
                                        initialValue={[
                                            {

                                            }
                                        ]}
                                    >
                                        {(fields, { add, remove }) => (
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    rowGap: 16,
                                                    flexDirection: 'column',
                                                }}
                                            >
                                                <Button
                                                    onClick={() => add()}
                                                    type="primary"
                                                    shape='round'
                                                    data-function="add"
                                                >
                                                    新增適用價格
                                                </Button>
                                                {fields.map((field) => (
                                                    <Space wrap align='start'>
                                                        <Form.Item
                                                            hidden
                                                            name={[field.name, "iFormulaRuleHistoryID"]}
                                                        >
                                                            <Input />
                                                        </Form.Item>
                                                        <Form.Item
                                                            rules={[
                                                                {
                                                                    required: true,
                                                                    message: "請填入日期"
                                                                }
                                                            ]}
                                                            name={[field.name, "tActivationTime"]}
                                                        >
                                                            <DatePicker
                                                                format={"YYYY-MM-DD"}
                                                            ></DatePicker>
                                                        </Form.Item>
                                                        <Form.Item
                                                            rules={[
                                                                {
                                                                    required: true,
                                                                    message: "請填入價格"
                                                                }
                                                            ]}
                                                            name={[field.name, "fNumeric"]}
                                                        >
                                                            <InputNumber />
                                                        </Form.Item>
                                                        <DeleteOutlined
                                                            style={{ cursor: 'pointer' }}
                                                            onClick={() => {
                                                                remove(field.name);
                                                            }}
                                                        />
                                                    </Space>
                                                ))}
                                            </div>
                                        )}
                                    </Form.List>
                                </Form.Item>
                            </Col>
                            <Col span={24} >
                                <Form.Item
                                    hidden
                                    labelWrap
                                    name={"tActivationTime"}
                                    // rules={[
                                    //     {
                                    //         required: true,
                                    //         message: "請選擇開始適用時間"
                                    //     }
                                    // ]}

                                    label={"開始適用時間"}
                                    labelCol={
                                        { span: 6 }
                                    }
                                    wrapperCol={
                                        { span: 18 }
                                    }
                                >
                                    <DatePicker
                                        format={"YYYY-MM-DD"}
                                    ></DatePicker>
                                </Form.Item>
                            </Col>
                            <Col span={24} >
                                <Form.Item
                                    hidden
                                    // name={"fNumeric"}
                                    // rules={[
                                    //     {
                                    //         required: true,
                                    //         message: "請輸入單價"
                                    //     }
                                    // ]}
                                    label={"單價"}
                                    labelCol={
                                        { span: 6 }
                                    }
                                    wrapperCol={
                                        { span: 18 }
                                    }
                                >
                                    <InputNumber
                                        min={0}
                                        placeholder={'請輸入單價'}
                                        // value={props.editcard['fNumeric']}
                                        onChange={value => props.setEditCard(prev => {
                                            return (
                                                {
                                                    ...prev,
                                                    fNumeric: value,
                                                }
                                            )
                                        })}
                                    />
                                </Form.Item>
                                <Form.Item
                                    name={"iUnitID"}
                                    rules={[
                                        {
                                            required: isCourseFee(count),
                                            message: "請選擇計價單位"
                                        }
                                    ]}
                                    label={"計價單位"}
                                    labelCol={
                                        { span: 6 }
                                    }
                                    wrapperCol={
                                        { span: 18 }
                                    }
                                >
                                    <Select
                                        allowClear={true}
                                        placeholder='請選擇計價單位'
                                        // style={{ width: 200 }}
                                        options={
                                            UnitTypeOption
                                        }
                                        onChange={value => props.setEditCard(prev => {
                                            return (
                                                {
                                                    ...prev,
                                                    iUnitID: value,
                                                }
                                            )
                                        })}
                                    />
                                </Form.Item>

                            </Col>
                            <Col span={24}>
                                <Form.Item
                                    name={"tRemark"}
                                    label={"備註"}
                                    labelCol={
                                        { span: 6 }
                                    }
                                    wrapperCol={
                                        { span: 18 }
                                    }
                                >
                                    <Input
                                        placeholder={'請輸入備註'}
                                        type='text'
                                        // value={props.editcard['tRemark']}
                                        onChange={e => props.setEditCard(prev => {
                                            return (
                                                {
                                                    ...prev,
                                                    tRemark: e.target.value,
                                                }
                                            )
                                        })}
                                    />
                                </Form.Item>

                            </Col>

                        </Row>

                    </Form>
                </Col>

            </Row>
        </AdminModal>
    </>)
}
export default TutionFeeDetailModal;